import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EdfiReaderForm from '../forms/edfi-reader-form';
import { edfiReaderValidationSchema } from '../schema/edfiReader.js';

export default function EdfiReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'EDFI Reader Node Details',
        altText: 'EDFI Reader Node',
        defaultLabel: 'EDFI Reader Node',
      }}
    >
      <CommonNode FormComponent={EdfiReaderForm} schemaResolver={edfiReaderValidationSchema} />
    </NodeProvider>
  );
}
